import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const PencilSolidIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9998 2.00028C20.666 0.666571 18.5037 0.666574 17.17 2.00028L15.4481 3.72217L20.2779 8.55196L21.9998 6.83007C23.3335 5.49636 23.3335 3.33399 21.9998 2.00028ZM18.9781 9.85173L14.1483 5.02194L3.13195 16.0383C2.44504 16.7252 1.98058 17.6028 1.79892 18.5571L1.27907 21.288C1.11736 22.1374 1.86259 22.8827 2.71205 22.721L5.44291 22.2011C6.39721 22.0195 7.27483 21.555 7.96174 20.8681L18.9781 9.85173Z"
      fill={props.color}
    />
  </svg>
)
